var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSadFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 120,
    viewBox: "0 0 85 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.263 52.337c6.59 0 11.262-4.77 11.262-11.065 0-6.296-4.671-11.002-11.262-11.002C4.735 30.27 0 34.976 0 41.272s4.735 11.065 11.263 11.065zm0 46.041c6.59 0 11.262-4.77 11.262-11.065 0-6.296-4.671-11.001-11.262-11.001C4.735 76.312 0 81.018 0 87.313c0 6.296 4.735 11.065 11.263 11.065z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.32 120h17.15c-9.6-12.146-16.895-37.202-16.895-60.032S74.871 12.02 84.47 0H67.32C54.394 15.517 48.315 35.803 48.315 59.968c0 23.975 6.015 44.325 19.006 60.032z",
    fill: "#666"
  })));
}

export default SvgSadFace;